export default __webpack_public_path__ + "a55a7b365ff31c500999ad7445eb7269.webp";